import { Directive } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { ComponentFactoryResolver, Optional, Input, Output } from '@angular/core';
import { NgControl } from '@angular/forms';
import { ElementRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appCommaseparatedarray]'
})
export class CommaSeparatedArrayDirective implements ControlValueAccessor {

  orig: ControlValueAccessor;
  private onChangeCallback: any;
  name: string;

  constructor( @Optional() ngControl: NgControl, private viewContainer: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver, private el: ElementRef) {
    this.name = el.nativeElement.name;
    const self = this;
    this.orig = ngControl.valueAccessor;
    ngControl.valueAccessor = this;
    this.orig.registerOnChange((newValue: string) => {
      if (self.onChangeCallback) {
        const arr = newValue.split(',').map(s => s.trim());
        self.onChangeCallback(arr);
      }
    });
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.orig.registerOnTouched(fn);
  }

  writeValue(value: any) {
    if (Array.isArray(value)) {
      const j = value.join(',');
      this.orig.writeValue(j);
    }
    else {
      this.orig.writeValue(value);
    }
  }
}
